<template>
  <!-- <div class="swiper-container faceDetail">
    <div class="swiper-wrapper">
      <div class="swiper-slide section section1 secTitle">
        <ProductionSlide1/>
      </div>
      <div class="swiper-slide section section4">
        <ProductionSlide2/>
      </div>
      <div class="swiper-slide section section3">
        <ProductionSlide3/>
      </div>
      <div class="swiper-slide section section4">
        <ProductionSlide4/>
      </div>
      <div class="swiper-slide section section5">
        <ProductionSlide5/>
      </div>
      <div class="swiper-slide section section5">
        <ProductionSlide6/>
      </div>
      <div class="swiper-slide footer footMenu">
        <Footer/>
      </div>
    </div>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>-->
  <div class="swiper-container productSet" style="overflow: auto">
    <div class="home-head">
      <TopHeader></TopHeader>
    </div>
    <!--    <swiper :options="swiperOption" class="swiper-no-swiping">-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        &lt;!&ndash; <ProductionSlide3New/> &ndash;&gt;-->
    <!--        &lt;!&ndash; <ProductionSlide2New/> &ndash;&gt;-->
    <!--        <ProductionSlide1/>-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        <ProductionSlide2New/>-->
    <!--        &lt;!&ndash; <ProductionSlide2/> &ndash;&gt;-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        <ProductionSlide4/>-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        <ProductionSlide3New/>-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        <ProductionSlide6/>-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item size-set">-->
    <!--        <ProductionSlide5/>-->
    <!--      </swiper-slide>-->
    <!--      <swiper-slide class="swiper-item footer-item">-->
    <!--        <Footer class="special-foot"></Footer>-->
    <!--      </swiper-slide>-->
    <!--      <div class="swiper-pagination" slot="pagination"></div>-->
    <!--    </swiper>-->
    <div class="production-content">
      <div class="content-box">
        <div class="aigis">
          <img class="aigis-img" src="../assets/AIGIS.png" alt="">
          <p class="aigis-p">AI地理信息计算</p>
          <p class="aigis-p"><span style="color: rgb(253,99,31)">AI</span><span>GIS</span></p>
          <div class="aigis-info">
            <p>精准图像识别</p>
            <p>空间轨迹分析</p>
            <p>综合行为分析</p>
          </div>
        </div>
        <div class="dsasr">
          <img class="dsasr-img" src="../assets/DSASR.png" alt="">
          <p class="dsasr-p">特定领域语音处理</p>
          <p class="dsasr-p"><span style="color: rgb(253,99,31);">DS</span><span>ASR</span></p>
          <div class="dsasr-info">
            <p>语音降噪增强</p>
            <p>实时语音识别</p>
            <p>指挥意图分析</p>
          </div>
        </div>
        <div class="cadsp">
          <img class="cadsp-img" src="../assets/CADSP.png" alt="">
          <p class="cadsp-p">民航数字信号处理</p>
          <p class="cadsp-p"><span style="color: rgb(253,99,31)">CA</span><span>DSP</span></p>
          <div class="cadsp-info">
            <p>航行数据处理</p>
            <p>多源数据融合</p>
            <p>业务场景建模</p>
          </div>
        </div>
      </div>
    </div>
    <div class="home-footer">
      <Footer class="special-foot"></Footer>
    </div>
  </div>
</template>

<style lang="scss">
.production-content {
  height: 100%;
  height: calc(100% - 164px);
  background: url("../assets/ability-bg.png");
  @include centerLine;
  background-repeat: no-repeat;
  background-position: center top 33%;
  background-size: cover;

  .content-box {
    display: flex;
    .cadsp {
      margin-left: 140px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .cadsp-img {
        width: 124px;
        height: 138px;
      }
      .cadsp-p{
        letter-spacing:2px;
        margin-top: 22px;
        font-size: 20px;
        text-align: center;
      }
      .cadsp-info{
        text-align: center;
        font-size: 18px;
        margin-top: 20px;
        font-weight: 100;
        letter-spacing:2px
      }
    }
    .dsasr {
      margin-left: 170px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .dsasr-img {
        width: 172px;
        height: 166px;
      }
      .dsasr-p{
        letter-spacing:2px;
        margin-top: 20px;
        font-size: 20px;
        text-align: center;
      }
      .dsasr-info{
        text-align: center;
        font-size: 18px;
        margin-top: 20px;
        font-weight: 100;
        letter-spacing:2px
      }
    }
    .aigis {
      display: flex;
      flex-direction: column;
      align-items: center;
      .aigis-img {
        width: 133px;
        height: 140px;
      }
      .aigis-p{
        letter-spacing:2px;
        margin-top: 20px;
        font-size: 20px;
        text-align: center;
      }
      .aigis-info{
        text-align: center;
        font-size: 18px;
        margin-top: 20px;
        font-weight: 100;
        letter-spacing:2px
      }
    }
  }
}

.special-foot {
  min-height: 164px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new_foot {
  background-color: #4d4d4d;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.productSet .home-head {
  width: 100%;
  z-index: 9;
  position: fixed;
  left: 0;
  height: calc(var(--bili) * 70);
  background: #060621;
  transition: all 1.5s ease-out;
}

.productSet .swiper-container-autoheight .swiper-slide {
  height: 100%;
}

.productSet .swiper-container-autoheight .swiper-slide:nth-child(7) {
  height: 258px;
  background-color: #4d4d4d;
  display: flex;
  justify-content: center;
  align-items: center;
}

.productSet .swiper-wrapper {
  height: 100% !important;
}

/* .footer-item > div {
  height: 100% !important;
} */
html,
body {
  width: 100%;
  height: 100%;
}

.swiper-container,
#app {
  width: 100%;
  height: 100%;
}

/* .swiper-container .swiper-slide {
  height: 300px;
  line-height: 300px;
  background: rgba(233, 0, 0, 0.4);
}
.swiper-container .swiper-slide:nth-child(2n) {
  height: 500px;
  line-height: 500px;
} */
</style>

<script>
// import ProductionSlide1 from "../components/HomeSlide1.vue";
// import ProductionSlide2 from "../components/ProductionSlide2.vue";
// import ProductionSlide3 from "../components/ProductionSlide3.vue";
// import ProductionSlide4 from "../components/ProductionSlide4.vue";
// import ProductionSlide5 from "../components/ProductionSlide5.vue";
// import ProductionSlide6 from "../components/ProductionSlide6.vue";
// import ProductionSlide2New from "../components/ProductionSlide2New.vue";
// import ProductionSlide3New from "../components/ProductionSlide3New.vue";
// import Footer from "../components/Footer.vue";
import TopHeader from "../../../common/compoments/TopHeader";
import Footer from "../components/Footer";
// require("../../../common/commonJS/swiper.min.js");
// import Swiper from "../../../common/commonJS/swiper.min.js";
export default {
  name: "production",
  components: {
    TopHeader,
    // ProductionSlide1,
    // ProductionSlide2,
    // ProductionSlide3,
    // ProductionSlide4,
    // ProductionSlide5,
    // ProductionSlide6,
    // ProductionSlide2New,
    // ProductionSlide3New,
    Footer
  },
  data() {
    return {
      // swiperOption: {
      //   direction: "vertical",
      //   autoHeight: true, //enable auto height
      //   spaceBetween: 20,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
      // }
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        autoHeight: true,
        mousewheel: true,
        autoHeight: true,
        setWrapperSize: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active"
        },
        on: {
          // 用于页头渐变颜色
          slideChangeTransitionStart: function () {
            console.log(this.realIndex);
            var ele = document.getElementsByClassName("home-head")[0];
            var eleFont = document.getElementsByClassName("head-selection")[0];
            var eleLogo = document.getElementsByClassName("logo")[0];
            var loginR = document
                .getElementsByClassName("right-selection")[0]
                .getElementsByTagName("div");
            if (this.realIndex == 0) {
              ele.style.background = "#060621";
              eleFont.style.color = "white";
              eleFont.getElementsByTagName("a")[0].style.color = "white";
              eleFont
                  .getElementsByClassName("ivu-dropdown-rel")[0]
                  .getElementsByTagName("a")[0].style.color = "white";
              eleLogo.className = "logo";
              loginR[0].className = "new_login new_login_bcon1";
              loginR[1].className = "new_login new_login_bcon2";
            } else {
              ele.style.background = "#F7F7F7";
              eleFont.style.color = "black";
              eleFont.getElementsByTagName("a")[0].style.color = "black";
              eleFont
                  .getElementsByClassName("ivu-dropdown-rel")[0]
                  .getElementsByTagName("a")[0].style.color = "black";
              eleLogo.className += " toggleLogo";
              loginR[0].className = "new_login new_login_bcon3";
              loginR[1].className = "new_login new_login_bcon4";
            }
          }
        }
      }
    };
  },
  created: function () {
  },
  mounted: function () {
    // this.initFN();
  },
  methods: {
    initFN() {
      var a = new Swiper(".swiper-container", {
        slidesPerView: "auto",
        // initialSlide: 0,
        // resistanceRatio: 0,
        // slideToClickedSlide: true,

        direction: "vertical",
        // slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
    }
  }
};
</script>
